import { z } from "zod";

export const CommissionScopeTypeFieldsSchema = z.object({
  id: z.number(),
  commissionScopeTypeId: z.number(),
  name: z.string(),
  type: z.number(),
  allowDelay: z.boolean(),
});

export const PartialCommissionScopeTypeFieldsSchema =
  CommissionScopeTypeFieldsSchema.deepPartial();

export const CommissionScopeTypeExtraFieldsSchema = z.object({
  availableTemplates: z.any(),
});
export const PartialCommissionScopeTypeExtraFieldsSchema =
  CommissionScopeTypeExtraFieldsSchema.deepPartial();

export const CommissionScopeTypeSchema = z.intersection(
  CommissionScopeTypeFieldsSchema,
  CommissionScopeTypeExtraFieldsSchema
);

export type CommissionScopeTypeFields = z.infer<
  typeof CommissionScopeTypeFieldsSchema
>;
export type PartialCommissionScopeTypeFields = z.infer<
  typeof PartialCommissionScopeTypeFieldsSchema
>;
export type CommissionScopeTypeExtraFields = z.infer<
  typeof CommissionScopeTypeExtraFieldsSchema
>;
export type PartialCommissionScopeTypeExtraFields = z.infer<
  typeof PartialCommissionScopeTypeExtraFieldsSchema
>;
export type CommissionScopeType = z.infer<typeof CommissionScopeTypeSchema>;
